// @flow
import React from "react";
import "./AudioRecorder.scss";
import { getMp3MediaRecorder } from "mp3-mediarecorder";
import vmsgWasm from "mp3-mediarecorder/dist/vmsg.wasm";

type Props = {
    onRecorded: Function,
    onRecordingStarted: Function,
    onRecordingStopped: Function,
    onError: Function,
    record: boolean
};

type State = {
    browserSupported: boolean,
    initialized: boolean,
    isRecording: boolean
};

export default class AudioRecorder extends React.PureComponent<Props, State> {
    recordedChunks: Array<Blob>;
    mediaRecorderPromise: Promise<MediaRecorder>;

    constructor(props: Props) {
        super(props);

        this.state = {
            browserSupported: true,
            isRecording: false,
            initialized: false
        };
    }

    checkRequirements = () => {};

    componentDidMount() {
        if (
            typeof navigator.mediaDevices !== "object" ||
            typeof navigator.mediaDevices.getUserMedia !== "function"
        ) {
            this.mediaRecorderPromise = Promise.reject(
                "This browser does not support recording audio."
            );
            this.props.onError(
                "This browser does not support recording audio."
            );
            return;
        }

        this.mediaRecorderPromise = Promise.all([
            getMp3MediaRecorder({ wasmURL: vmsgWasm }),
            navigator.mediaDevices.getUserMedia({ audio: true })
        ]).then(vals => {
            let mp3MediaRecorder = vals[0];
            let mediaStream = vals[1];

            return new mp3MediaRecorder(mediaStream);
        });

        this.mediaRecorderPromise.then(mediaRecorder => {
            this.setState((old: State) => ({ ...old, initialized: true }));

            mediaRecorder.onstart = this.handleRecordingStarted;
            mediaRecorder.ondataavailable = this.handleRecordedData;
            mediaRecorder.onstop = this.handleRecordingStopped;
            mediaRecorder.onerror = this.handleRecordingError;
        });

        this.mediaRecorderPromise.catch(e => {
            this.props.onError(
                "Cannot initialize audio recorder: " + e.toString()
            );
        });
        if (this.props.record) {
            this.startRecording();
        }
    }

    componentWillUnmount() {
        this.mediaRecorderPromise.then(mediaRecorder => {
            mediaRecorder.stream.getTracks().forEach(track => track.stop());
            mediaRecorder.onstart = null;
            mediaRecorder.ondataavailable = null;
            mediaRecorder.onstop = null;
        });
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.record && !prevProps.record) {
            this.startRecording();
        } else if (!this.props.record && prevProps.record) {
            this.stopRecording();
        }
    }

    render = () => {
        return (
            <div className="AudioRecorder">
                <div className="AudioRecorder__Icon" />
                {this.renderContents()}
            </div>
        );
    };

    renderContents = () => {
        if (this.state.initialized) {
            return <div>Audio recorder is ready.</div>;
        }

        return <div>Waiting for audio stream...</div>;
    };

    handleRecordingStopped = () => {
        this.props.onRecordingStopped();
        this.setState(state => ({ ...state, isRecording: false }));
        this.props.onRecorded(
            new File(this.recordedChunks, "audio.mp3", { type: "audio/mpeg" })
        );

        //Cleanup
        this.recordedChunks = [];
    };

    handleRecordedData = e => {
        this.recordedChunks.push(e.data);
    };

    handleRecordingError = e => {
        this.props.onError("Recording error.");
    };

    handleRecordingStarted = e => {
        this.setState(state => ({ ...state, isRecording: true }));
        this.props.onRecordingStarted();
    };

    startRecording = () => {
        this.recordedChunks = [];
        this.mediaRecorderPromise.then(recorder => recorder.start());
    };

    stopRecording = () => {
        this.mediaRecorderPromise.then(recorder => recorder.stop());
    };
}



// WEBPACK FOOTER //
// ./src/app/components/MediaRecorder/AudioRecorder/AudioRecorder.js